import React, { type FC } from 'react';
import AkLabelIcon from '@atlaskit/icon/glyph/label';
import OfficeBuildingFilledIcon from '@atlaskit/icon/glyph/office-building-filled';
import type { GlyphProps } from '@atlaskit/icon/types';
import { Box, xcss } from '@atlaskit/primitives';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

type LabelIcon = {
	size: 'large' | 'small' | 'xsmall';
	type: 'ORGANIZATION' | 'PRODUCT';
	label?: string;
} & Omit<GlyphProps, 'size' | 'label'>;

export const LabelIcon: FC<LabelIcon> = ({ size, type, label = '', ...etc }) => {
	// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
	const Icon = type === 'ORGANIZATION' ? OfficeBuildingFilledIcon : AkLabelIcon;
	const iconSize = size === 'large' ? ('large' as const) : ('small' as const);

	return (
		<Box
			xcss={[
				containerStyles,
				size === 'large' && largeStyles,
				size === 'small' && smallStyles,
				size === 'xsmall' && xsmallStyles,
			]}
		>
			<Icon
				primaryColor={token('color.icon', colors.N500)}
				size={iconSize}
				label={label}
				{...etc}
			/>
		</Box>
	);
};

const containerStyles = xcss({
	display: 'flex',
	backgroundColor: 'color.background.neutral',
});

const largeStyles = xcss({
	borderRadius: 'border.radius.200',
	padding: 'space.050',
});

const smallStyles = xcss({
	borderRadius: 'border.radius.050',
	padding: 'space.050',
});

const xsmallStyles = xcss({
	borderRadius: 'border.radius.050',
	padding: 'space.025',
});
